import {CartaFeatureList, GeojsonConverter} from 'ng-carta';
import Feature from 'ol/feature';


export class NotifyingCartaFeatureList extends CartaFeatureList {
  pmDestination = undefined;
  pmOrigin = undefined;

  public setPostMessageDestination(destination: Window, origin: string) {
    this.pmDestination = destination;
    this.pmOrigin = origin;
  }

  private sendGeoJson() {
    if (this.pmDestination === undefined) {
      return;
    }

    const features = this.getArray();
    const geoJson = GeojsonConverter.toGeojson(features);
    this.pmDestination.postMessage(JSON.stringify(geoJson), this.pmOrigin);
  }

  push(elem: Feature): number {
    const value = super.push(elem);
    elem.getGeometry().on('change', function () {
      // noinspection JSPotentiallyInvalidUsageOfClassThis
      this.sendGeoJson();
    }.bind(this));
    this.sendGeoJson();
    return value;
  }

  remove(elem: Feature): (Feature) {
    const value = super.remove(elem);
    this.sendGeoJson();
    return value;
  }
}
